import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// ---Third-party imports
import React, { useState } from 'react';
import clsx from 'clsx';
// ---Framework imports
// ---Local imports
import { useOffsetNavigation } from 'uix/frontend/hooks';
import { Button, Dropdown } from './nativeComps';
import S from './pageNavigator.scss';
export const PageNavigator = ({ className, max, offset, total, navigation = true, pagination = true, indicator = false })=>{
    let { setOffset } = useOffsetNavigation();
    let totalPages = Math.floor((total || 0) / max) + 1;
    let activePage = Math.floor(offset / max) + 1;
    //max elements shown in selected view
    let maxView = null;
    if (offset + max > total) {
        maxView = total;
    } else {
        maxView = offset + max;
    }
    let PaginationItems = ({ active, total })=>{
        const paginationItems = [];
        const arr = Array.from({
            length: total
        }, (_, i)=>i + 1);
        let Ellipsis = (key)=>/*#__PURE__*/ _jsx(Button, {
                disabled: true,
                content: "..."
            }, key);
        let createPaginationItem = (i)=>{
            return /*#__PURE__*/ _jsx(Button, {
                onClick: ()=>setOffset(max * (i - 1)),
                active: i === active,
                children: i
            }, i);
        };
        //calculating which pages are visible:
        let lngth = 5;
        if (arr.length > 9) {
            if (active < lngth) {
                for(let i = 1; i <= lngth; i++){
                    paginationItems.push(createPaginationItem(i));
                }
                paginationItems.push(/*#__PURE__*/ _jsx(Ellipsis, {}, "more"));
                paginationItems.push(createPaginationItem(total));
                return paginationItems;
            }
            if (active >= lngth && active < total - lngth + 2) {
                paginationItems.push(createPaginationItem(1));
                paginationItems.push(/*#__PURE__*/ _jsx(Ellipsis, {}, "before"));
                for(let i = active - 1; i <= active + 1; i++){
                    paginationItems.push(createPaginationItem(i));
                }
                paginationItems.push(/*#__PURE__*/ _jsx(Ellipsis, {}, "after"));
                paginationItems.push(createPaginationItem(total));
                return paginationItems;
            }
            if (active >= total - lngth) {
                paginationItems.push(createPaginationItem(1));
                paginationItems.push(/*#__PURE__*/ _jsx(Ellipsis, {}, "less"));
                for(let i = total - lngth + 1; i <= total; i++){
                    paginationItems.push(createPaginationItem(i));
                }
                return paginationItems;
            }
        } else {
            return arr.map((item)=>{
                return createPaginationItem(item);
            });
        }
    };
    const Indicator = ()=>{
        let ddIndicator = [];
        let disabled = false;
        let setIndicator = (value)=>{
            setOffset(value == 0 ? 0 : value * max);
        };
        if (totalPages > 1 && totalPages <= 20) {
            for(let i = 0; i < totalPages; i++){
                if (i === 0) {
                    ddIndicator.push({
                        value: i,
                        text: `1 - ${max}`
                    });
                }
                if (i > 0 && i < totalPages - 1) {
                    ddIndicator.push({
                        value: i,
                        text: `${i * max + 1} - ${i * max + max}`
                    });
                }
                if (i == totalPages - 1) {
                    ddIndicator.push({
                        value: i,
                        text: `${i * max + 1} - ${total}`
                    });
                }
            }
        } else {
            ddIndicator = [
                {
                    text: `${offset + 1} - ${maxView}`
                }
            ];
            disabled = true;
        }
        return /*#__PURE__*/ _jsx(Dropdown, {
            simple: true,
            disabled: disabled,
            selected: activePage - 1,
            onSetValue: setIndicator,
            options: ddIndicator,
            className: S.indicator
        });
    };
    return /*#__PURE__*/ _jsxs("span", {
        className: clsx(className, 'pagingControls', S.pageNavigator),
        children: [
            navigation && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        disabled: offset < 1 && true,
                        content: "|<",
                        onClick: ()=>setOffset(0)
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        disabled: offset < 1 && true,
                        content: "<",
                        onClick: ()=>setOffset(offset - max)
                    })
                ]
            }),
            pagination && /*#__PURE__*/ _jsx(PaginationItems, {
                active: activePage,
                total: totalPages
            }),
            indicator && /*#__PURE__*/ _jsx(Indicator, {}),
            navigation && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        disabled: offset + max > total && true,
                        content: ">",
                        onClick: ()=>setOffset(offset + max)
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        disabled: offset + max > total && true,
                        content: ">|",
                        onClick: ()=>setOffset(totalPages * max - max)
                    })
                ]
            })
        ]
    });
};
